// extracted by mini-css-extract-plugin
export default {"root":"ScrollableContainer_root__---LB","list":"ScrollableContainer_list__PcYSg"};